import type { ColDef, ValueGetterParams } from 'ag-grid-enterprise'
import type { IBadgeCellRendererParams } from '~/types/badge'
import type { IUserAdmin } from '~/types/user'

import BadgeCellRenderer from '~/components/CellRenderers/BadgeCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { badgeColDef, identityColDef, lastUpdateColDef, textColDef } from '~/utils/table'

const columns: ColDef[] = [
  identityColDef({
    field: 'identity',
    headerName: 'User',
    suppressHeaderMenuButton: true,
    valueGetter: ({ data }: ValueGetterParams<IUserAdmin>): IUserAdmin | undefined => data,
  }),
  textColDef(TextCellRenderer, {
    field: 'email',
    headerName: 'Email',
    suppressHeaderMenuButton: true,
  }),
  badgeColDef(BadgeCellRenderer, {
    field: 'groups',
    filterValueGetter: ({ data }: ValueGetterParams<IUserAdmin>): string[] | undefined =>
      data?.groups?.map(({ group_name }) => group_name),
    headerName: 'Groups',
    valueGetter: ({ data }: ValueGetterParams<IUserAdmin>): IBadgeCellRendererParams | undefined => {
      if (!data) return undefined

      const { groups } = data

      return {
        data:
          groups?.map(({ group_name, id }) => ({
            id,
            name: group_name,
          })) || [],
        type: 'group',
      }
    },
  }),
  badgeColDef(BadgeCellRenderer, {
    field: 'specific_roles',
    filterValueGetter: ({ data }: ValueGetterParams<IUserAdmin>): string[] | undefined =>
      data?.roles?.map(({ name }) => name),
    headerName: 'Specific roles',
    valueGetter: ({ data }: ValueGetterParams<IUserAdmin>): IBadgeCellRendererParams | undefined => {
      if (!data) return undefined

      const { roles } = data

      return {
        data:
          roles?.map(({ name, role_id }) => ({
            id: role_id,
            name,
          })) || [],
        type: 'role',
      }
    },
  }),
  lastUpdateColDef({
    field: 'last_update',
    suppressHeaderMenuButton: true,
  }),
]

export default columns
